import { createContext, useContext } from 'react';
import { IListEmail } from '../constants';

interface IEmailListContext {
  listIds: string[];
  listData: Record<string, IListEmail>;
}

export const EmailListContext = createContext<IEmailListContext>({
  listIds: [],
  listData: {},
});

export const useEmailListContext = () => {
  const context = useContext(EmailListContext);
  if (!context) {
    throw new Error('useEmailListContext must be used within EmailListContext.Provider');
  }
  return context;
};
